module.exports = __webpack_public_path__ + "static/media/porc.b4b42b98.svg";